import React, { useEffect, useRef, useState } from "react";
import { Grow, Grid, FormControlLabel, Switch } from "@mui/material";
import TotalFunnel from "./components/TotalFunnel";
import { CSSTransition, TransitionGroup } from "react-transition-group";
import Dropdown from "../selectClientPositionDropdown/ClientPositionDropdown";
import "./styles.css";

import { Container, Button, Alert } from "react-bootstrap";
import ClientTable from "./components/ClientTable";
import ClientPosList from "./components/ClientPosList";
import PieChart from "./components/PieChart";
import { useContext } from "react";
import DataContext from "../../../context/DataContext";
import NumberCard from "../../NumberCard";
import DollarCard from "../../DollarCard";

export default function ClientSpecificView({
  data,
  clientFunnelData,
  clientPositions,
  clientChecked,
  clientPieChartData,
}) {
  

  return (
    <Grid container spacing={3}>
      <Grow in={clientChecked} mountOnEnter unmountOnExit>
        <Grid item xl={4} lg={4} md={4} sm={4} xs={12}>
          <NumberCard
            title={"Total Positions"}
            data={data.totalPositions}
          ></NumberCard>
        </Grid>
      </Grow>
      <Grow
        in={clientChecked}
        style={{ transformOrigin: "0 0 0" }}
        {...(clientChecked ? { timeout: 1000 } : {})}
        mountOnEnter
        unmountOnExit
      >
        <Grid item xl={4} lg={4} md={4} sm={4} xs={12}>
          <NumberCard
            title={"Active Vacancies"}
            data={data.vacancies}
          ></NumberCard>
        </Grid>
      </Grow>

      <Grow
        in={clientChecked}
        style={{ transformOrigin: "0 0 0" }}
        {...(clientChecked ? { timeout: 1000 } : {})}
        mountOnEnter
        unmountOnExit
      >
        <Grid item xl={4} lg={4} md={4} sm={4} xs={12}>
          <DollarCard title={"Total Hiring Costs"} data={data.hiringCosts} />
        </Grid>
      </Grow>

      <Grow in={clientChecked} mountOnEnter unmountOnExit>
        <Grid item xl={7} lg={7} md={6} sm={12} xs={12}>
          <ClientPosList positions={clientPositions} />
        </Grid>
      </Grow>
      <Grow
        in={clientChecked}
        style={{ transformOrigin: "0 0 0" }}
        {...(clientChecked ? { timeout: 1000 } : {})}
        mountOnEnter
        unmountOnExit
      >
        <Grid item xl={5} lg={5} md={6} sm={12} xs={12}>
          <TotalFunnel data={clientFunnelData} />
        </Grid>
      </Grow>

      <Grow
        in={clientChecked}
        style={{ transformOrigin: "0 0 0" }}
        {...(clientChecked ? { timeout: 1000 } : {})}
        mountOnEnter
        unmountOnExit
      >
        <Grid item xl={5} lg={5} md={5} sm={12} xs={12}>
          <PieChart data={clientPieChartData} />
        </Grid>
      </Grow>
      <Grow
        in={clientChecked}
        style={{ transformOrigin: "0 0 0" }}
        {...(clientChecked ? { timeout: 1000 } : {})}
        mountOnEnter
        unmountOnExit
      >
        <Grid item xl={7} lg={7} md={7} sm={12} xs={12}>
          <ClientTable positions={clientPositions} />
        </Grid>
      </Grow>
    </Grid>
  );
}
